/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Grid } from '@mui/material';
import React from 'react'
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import AccessViewList from '../views/AccessViewList';


const ManageAccessPage = () => {


    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'View Access'} />
                    </Grid>
                </Grid>
                <Grid container spacing={4} style={{ marginTop: '10px' }}>
                
                    <Grid item xs={12} sm={12} md={12}>
                        <AccessViewList />
                    </Grid>
                </Grid>
            </Box>

        </>
    )

}

export default ManageAccessPage;
